// plugins/utm.js
export default ({ query }) => {
  const isHaveUtm = Object.keys(query).some((key) => key.startsWith('utm_'))
  const isHaveGclId = Object.keys(query).includes('gclid')
  if (isHaveUtm || isHaveGclId) {
    sessionStorage.setItem('utmQuery', JSON.stringify(query))
  }
}
